


















































import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import { createPopper } from '@popperjs/core';
import { tagRegStr, getTagList } from "@/services/config";

@Component
export default class TextEditor extends Vue {
  @Model('change')
  value!: string;

  @Emit('change')
  change() {
     return this.getNewValue();
  }

  @Watch('value')
    getValue(value: string) {
      if (value !== this.getNewValue()) {
          const reg = new RegExp(tagRegStr, 'g');
          (this.$refs.editor as HTMLElement).innerHTML = value.replace(reg, (str: string) => {
              const regArr = str.match(new RegExp(tagRegStr))||[];
              const id = this.guid();
              const key = regArr[1];
              const defaultValue = regArr[2];
              const label = this.tagList.find(item => item.value === key)?.label || key;
              this.$nextTick(() => this.itemClickListener(id));
              return `<input id="${id}" name="{{${key}|default:'${defaultValue}'}}" type="button" class="text-editor-inner-tag" value="${label}">`
          }).replace(/\s\s/g,'&nbsp;&nbsp;');
      }
  }

  @Prop({
    type: String,
    default() {
        return '';
    },
  })
  placeholder!: string;

  // 光标位置
  public selectionRange!: Range;
  // 标签详情
  public tooltipVisible = false;
  // 当前标签属性
  public activeTag: {
      key: string;
      defaultValue: string;
      element: HTMLInputElement | null;
  } = {
      key: '',
      defaultValue: '',
      element: null
  }
  public tagList = getTagList();

  beforeDestroy() {
    document.removeEventListener('click', this.chooseTag, true);
  }
  
  mounted() {
    document.addEventListener(
      "click",
      this.chooseTag,
      true
    );
    this.getValue(this.value);
  }

    htmlDecode(input: string) {
        const doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    getNewValue() {
        return this.htmlDecode((this.$refs.editor as HTMLElement).innerHTML.replace(new RegExp('<input[^>]*name="([^"]+)"[^>]*>', 'g'), '$1'))
    }
  /**
   * tag点击空白事件
   */ 
  chooseTag(e: any) {
    let tooltipVisible = false;
    const tags = (this.$refs.editor as HTMLElement).getElementsByClassName('text-editor-inner-tag')||[];
    for (let i = 0; i < tags.length; i++) {
      if (tags[i] && tags[i].contains(e.target)) {
          tooltipVisible = true;
          break;
      }
    }
    if (this.$refs.tooltip && (this.$refs.tooltip as HTMLElement).contains(e.target)) {
        tooltipVisible = true;
    }
    this.tooltipVisible = tooltipVisible;
    if (!this.tooltipVisible && this.activeTag.element) {
      this.activeTag.element.className = 'text-editor-inner-tag';
    }
  }

  /**
   * 选择时恢复光标位置
   */ 
  showTagList() {
      if(!this.selectionRange) {
          this.initRange(this.$refs.editor as HTMLElement);
      } else {
          this.restoreRange(this.selectionRange);
      }
  }
  
  /**
  * 新增属性
  * @param item
  */
  addTag(item: {label: string, value: string}) {
    const editor = this.$refs.editor as HTMLElement;
    editor?.focus();
    this.restoreRange(this.selectionRange);
    const id = this.guid();
    const tag = `<input id="${id}" name="{{${item.value}|default:''}}" type="button" class="text-editor-inner-tag" value="${item.label}">`;
    document.execCommand('insertHTML', false, tag);
    this.itemClickListener(id);
    (this.$refs.popover as any).doClose();
    this.$nextTick(() => {
      document.getElementById(`${id}`)?.click();
    })
  }

  /**
   * tag事件
   */
  itemClickListener(id: string) {
      const tagElement = document.getElementById(`${id}`);
      tagElement?.addEventListener('click', () => {
          this.tooltipVisible = true;
          if (this.activeTag.element) {
              this.activeTag.element.className = 'text-editor-inner-tag';
          }
          const tooltip = this.$refs.tooltip;
          const tagReg = ((tagElement as HTMLInputElement).name.match(new RegExp(tagRegStr)) || ['','',''])
          this.activeTag.key = tagReg[1];
          this.activeTag.defaultValue = tagReg[2];
          this.activeTag.element = (tagElement as HTMLInputElement);
          tagElement.className = 'text-editor-inner-tag active';
          createPopper(tagElement as HTMLElement, tooltip as HTMLElement, {
              placement: 'top',
          });
      })
  }

  /**
   * 保存tag默认值
   */
  saveTagValue() {
    if (this.activeTag.element) {
      this.activeTag.element.name = `{{${this.activeTag.key}|default:'${this.activeTag.defaultValue}'}}`
      this.activeTag.element.className = 'text-editor-inner-tag';
    }
    this.tooltipVisible = false;
    this.change();
  }

  /**
   * 关闭tag编辑
   */
  closeTagValue() {
    if (this.activeTag.element) {
      this.activeTag.element.className = 'text-editor-inner-tag';
    }
    this.tooltipVisible = false;
  }

  /**
  * 监听光标变化
  */
  addSelectionchangeListener() {
    document.addEventListener('selectionchange', this.onSelectionChange);
  }

  /**
  * 解除监听光标变化
  */
  removeSelectionchangeListener() {
    document.removeEventListener('selectionchange', this.onSelectionChange);
  }

  /**
  * 恢复光标位置
  * @param range
  */
  restoreRange(range: Range) {
    const selection = document.getSelection();
    if (!selection) {
        return;
    }
    selection.removeAllRanges();
    const newRange = document.createRange();
    newRange.setStart(range.startContainer, range.startOffset);
    newRange.setEnd(range.endContainer, range.endOffset);

    selection.addRange(newRange);
  }

  /**
  * 光标位置变化事件
  */
  onSelectionChange() {
      try {
          const range = document.getSelection()?.getRangeAt(0);
          if (range) {
              this.selectionRange = range;
          }
      } catch (error) {}
  }

  /**
  * 设置光标初始位置
  * @param element
  */
  initRange (element: HTMLElement) {
    const selection = document.getSelection();
    if (!selection) {
        return;
    }
    selection.removeAllRanges();
    const newRange = document.createRange();
    newRange.selectNodeContents(element);
    newRange.setEnd(newRange.endContainer, 0);

    this.selectionRange = newRange;
    selection.addRange(newRange);
  }

    S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    guid() {
        return (this.S4()+this.S4()+"-"+this.S4()+"-"+this.S4()+"-"+this.S4()+"-"+this.S4()+this.S4()+this.S4());
    }
  textPaste(event: any) {
    event.preventDefault();
    let text;
    const clp = (event.originalEvent || event).clipboardData;
    // 兼容针对于opera ie等浏览器
    if (clp === undefined || clp === null) {
        // @ts-ignore
        text = window.clipboardData.getData("text") || "";
        if (text !== "") {
            if (window.getSelection) {
                // 针对于ie11 10 9
                const newNode = document.createElement("span");
                newNode.innerHTML = text;
                window.getSelection()?.getRangeAt(0).insertNode(newNode);
            } else {
                // @ts-ignore 兼容ie10 9 8 7 6 5
                document.selection.createRange().pasteHTML(text);
            }
        }
    } else {
        // 兼容chorme或hotfire
        text = (clp.getData('text/plain') || "").replace(/\n/g, ' ');
        if (text !== "") {
            document.execCommand('insertText', false, text);
        }
    }
  }

}

